const color = {
  state: {
    recentColors: [],
  },

  mutations: {
    ADD_COLOR: (state, color) => {
      let recentColors = state.recentColors.filter(e => e!==color);
      recentColors.unshift(color);
      recentColors = recentColors.slice(0, 10);
      localStorage.setItem("recentColors", JSON.stringify(recentColors));
      state.recentColors = recentColors;
    },
    INIT_COLOR: (state) => {
      let storageRecentColors = localStorage.getItem("recentColors");
      if(storageRecentColors) {
        state.recentColors = JSON.parse(storageRecentColors);
      }else {
        state.recentColors = ['#FFFFFF', '#000000', '#118DFF', '#12239E', '#E66C37', '#6B007B', '#E044A7', '#744EC2', '#D9B300', '#D64550']
      }
    }
  },

}

export default color;